import creator from './helpers/creator';
import device from './helpers/device';

import Token from './modules/Token';
import Preloader from './modules/Preloader';
import Fetch from './modules/Fetch';
import FetchWithParam from './modules/FetchWithParam';
import Overlay from './modules/Overlay';
import Menu from './modules/Menu';
import Collapsible from './modules/Collapsible';
import Dropdowns from './modules/Dropdowns';
import SliderCare from './modules/SliderCare';
import LazyVideo from './modules/LazyVideo';
import LazyLoadModule from './modules/LazyImage';
import Rotate from './modules/Rotate';
import Animate from './modules/Animate';
import Video from './modules/Video';
import SwipeCards from './modules/SwipeCards';
import Stepper from './modules/Stepper';
import Credits from './modules/Credits';
import ZoomImage from './modules/ZoomImage';
import UpdateRootVars from './modules/UpdateRootVars';
import Collection from './modules/Collection';
import BoldDate from './modules/BoldDate';
import FetchArt from './modules/FetchArt';
import Filter from './modules/Filter';
import SpaLottie from './modules/SpaLottie';

document.addEventListener('DOMContentLoaded', () => {
  window.token = new Token();

  if (!document.body.classList.contains('single')) {
    window.fetchwithparam = new FetchWithParam();
    window.fetchdata = new Fetch();
    window.overlay = new Overlay();
    window.preloader = new Preloader();
    window.spalottie = new SpaLottie();
  }

  // if (document.body.classList.contains('single')) {
  //   window.storylink    = new StoryLink()
  // }

  // window.lazyimage      = new LazyLoadModule()
  window.lazyvideo = new LazyVideo();
  window.updaterootvars = new UpdateRootVars();
  window.rotate = new Rotate();
  window.menu = creator('.js-header', Menu);
  window.collapsible = creator('.js-header', Collapsible);
  window.animate = new Animate();
  if (window.location.href.includes('singleurl')) {
    window.fetchart = new FetchArt();
  }

  window.video = creator('.js-card', Video);
  window.looks = creator('.js-looks', SwipeCards);
  window.collections = creator('.single-collection', Collection);
  
  // Initialize dropdowns if they exist on page load
  if (document.querySelector('.dropdowns')) {
    window.dropdowns = creator('.dropdowns', Dropdowns);
  }
  
  // Initialize slider-care if it exists on page load
  if (document.querySelector('.slider-care')) {
    window.sliderCare = creator('.slider-care', SliderCare);
  }
});

window.addEventListener('fetch:done', () => {
  window.stepper = creator('.js-stepper', Stepper);
  window.credits = creator('.js-credits', Credits);
  window.zoomimage = creator('.js-zoom-image', ZoomImage);
  window.bolddate = creator('.js-date', BoldDate);
  window.dropdowns = creator('.dropdowns', Dropdowns);
  window.sliderCare = creator('.slider-care', SliderCare);
  window.filters = [];
  document.querySelectorAll('.js-filterable').forEach((tabContent) => {
    window.filters.push(new Filter(tabContent));
  });
});

if (device.isSafari) {
  document.body.classList.add('is-safari');
}
if (device.isChrome) {
  document.body.classList.add('is-chrome');
}
